module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_serpref"
    }
  }, [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_abbrev"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Concerning foreigners and the Former Prophets")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch01#sigil_toc_id_2"
    }
  }, [_vm._v("Being a foreigner and reading the Bible")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch01#sigil_toc_id_3"
    }
  }, [_vm._v("Why the Former Prophets?")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch01#sigil_toc_id_4"
    }
  }, [_vm._v("Towards an ethical and theological reading of the Former Prophets")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 The book of Joshua: the identity of the people of God")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_6"
    }
  }, [_vm._v("Initial observations: the genre and language of Joshua")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_7"
    }
  }, [_vm._v("Rahab and the initial entry into the land (Josh. 1 – 6)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_8"
    }
  }, [_vm._v("Achan (Josh. 7:1 – 8:29)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_9"
    }
  }, [_vm._v("The altar on Mount Ebal and the Gibeonites (Josh. 8:30 – 12:24)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_10"
    }
  }, [_vm._v("Caleb, the surviving Canaanites and the cities of refuge (Josh. 13 – 21)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_11"
    }
  }, [_vm._v("The altar on the Jordan (Josh. 22)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_12"
    }
  }, [_vm._v("The threat of all and an invitation to all (Josh. 23 – 24)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_ch02#sigil_toc_id_13"
    }
  }, [_vm._v("Conclusions: Joshua as the formation of the people of God")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 The book of Judges: the people through whom Yahweh works")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch03#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initial orientation")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch03#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After Joshua: Judges 1:1 – 3:6")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch03#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The stories of the judges: Judges 3:7 – 16:31")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch03#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When there was no king: Judges 17 – 21")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch03#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions on Judges: the people through whom Yahweh works")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 The books of Samuel: foreigners as the means of assessing Israel")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch04#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initial orientation")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch04#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel: 1 Samuel 1 – 12")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch04#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saul: 1 Samuel 13 – 15")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch04#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saul and David, Ish-bosheth and David: 1 Samuel 16:1 – 2 Samuel 5:16")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch04#sigil_toc_id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David as king: 2 Samuel 5:17 – 24:25")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch04#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions: Samuel and understanding the people of God")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5 The books of Kings: foreigners beyond the borders of Israel")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch05#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initial orientation")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch05#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon: 1 Kings 1 – 11")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch05#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two kingdoms: 1 Kings 12 – 2 Kings 13")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch05#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The fall of the kingdoms: 2 Kings 14 – 25")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch05#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions: kings and foreigners beyond the borders of Israel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 Foreigners and the people of God")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch06#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initial orientation: key themes from the Former Prophets")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch06#sigil_toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Echoes in the Old Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch06#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Echoes in the New Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_ch06#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pointers for an ethic towards foreigners")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_idx_aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search names for authors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_idx_scr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search items for Scripture references")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_idx_ancsrc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search items for ancient sources")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ITS_sertit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titles in this series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/aboutcontrib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the contributors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736d2a71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ITS_contents.vue
// module id = 66
// module chunks = 0